import React from "react";

import { WizardSubjectSelection } from "../../../../components/WizardSubjectSelection";
import { InlineError } from "../components/InlineError";

import { EMPLOYEES_STEP_ID, EMPLOYEES_STEP_TITLE } from "../launch-form";

type SelectEmployeesStepProps = {
	stepTitle: string;
	userSelectionId: string | null;
	onSelectionCreated: (id: string) => void;
	showSelectionError: boolean;
};

/** Step 2 — pick the subjects of the workflow. */
export const SelectEmployeesStep = ({
	stepTitle,
	userSelectionId,
	onSelectionCreated,
	showSelectionError,
}: SelectEmployeesStepProps) => (
	<WizardSubjectSelection
		stepTitle={stepTitle}
		subtitle={EMPLOYEES_STEP_TITLE}
		stepId={EMPLOYEES_STEP_ID}
		userSelectionId={userSelectionId}
		onSelectionCreated={onSelectionCreated}
		error={
			showSelectionError ? (
				<InlineError
					message="At least one subject must be selected to continue."
					data-testid="selection-error"
				/>
			) : null
		}
	/>
);
